import { gql, TypedDocumentNode } from "@apollo/client";

export type FinalizeMemberElectionsMutationResponse = {
  finalizeMemberElections: {
    success: boolean;
    message: string;
    successfulApplicationIds: string[];
    failedApplicationIds: string[];
  };
};

export type FinalizeMemberElectionsMutationVariables = {
  applicationIds: string[];
};

export const FINALIZE_MEMBER_ELECTIONS_MUTATION: TypedDocumentNode<
  FinalizeMemberElectionsMutationResponse,
  FinalizeMemberElectionsMutationVariables
> = gql`
  mutation FinalizeMemberElections($applicationIds: [ID!]!) {
    finalizeMemberElections(applicationIds: $applicationIds) {
      success
      message
      successfulApplicationIds
      failedApplicationIds
    }
  }
`;

export type UpdateMembershipApplicationElectionDatesResponse = {
  updateMembershipApplicationElectionDates: {
    success: boolean;
    message: string;
    updatedCount: number;
  };
};

export type UpdateMembershipApplicationElectionDatesVariables = {
  input: {
    applicationIds: string[];
    electionDateId?: string | null;
  };
};

export const UPDATE_MEMBERSHIP_APPLICATION_ELECTION_DATES_MUTATION: TypedDocumentNode<
  UpdateMembershipApplicationElectionDatesResponse,
  UpdateMembershipApplicationElectionDatesVariables
> = gql`
  mutation UpdateMembershipApplicationElectionDates($input: UpdateMembershipApplicationElectionDatesInput!) {
    updateMembershipApplicationElectionDates(input: $input) {
      success
      message
      updatedCount
    }
  }
`;
